//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  props: {
    size: {
      type: String,
      default: 'medium'
    }
  },
  computed: {
    dimensions() {
      switch (this.size) {
        case 'icon':
          return {
            px: 14,
            radius: 5
          };

        case 'small':
          return {
            px: 20,
            radius: 9
          };

        case 'medium':
          return {
            px: 30,
            radius: 13.5
          };

        case 'large':
          return {
            px: 50,
            radius: 22.5
          };

        default:
          return {
            name: 'medium',
            px: 30,
            radius: 13.5
          };
      }
    },

    origin() {
      return this.dimensions.px / 2;
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Spinner/Spinner.vue_rollup-plugin-vue=script.js